import { doLoadOrderAction } from 'state';
import { createKeyedDataAsyncSlice } from 'store/createKeyedDataAsyncSlice';

export const { slice: orderInformationSlice, asyncAction: getOrderByIDAsyncAction } = createKeyedDataAsyncSlice(
  'orderInformation',
  doLoadOrderAction,
  (x) => x
);
